import React from 'react';
interface MetricsCardProps {
  title: string;
  value: number | string;
  subtitle?: string;
  icon?: React.ReactNode;
}
export function MetricsCard({
  title,
  value,
  subtitle,
  icon
}: MetricsCardProps) {
  return <div className="bg-crown-surface border border-crown-border rounded-lg p-6" data-id="element-10">
      <div className="flex items-start justify-between mb-4" data-id="element-11">
        <h3 className="text-sm font-medium text-crown-body" data-id="element-12">{title}</h3>
        {icon && <div className="text-crown-red" data-id="element-13">{icon}</div>}
      </div>
      <div className="space-y-1" data-id="element-14">
        <p className="text-3xl font-bold text-crown-text" data-id="element-15">{value}</p>
        {subtitle && <p className="text-xs text-crown-muted" data-id="element-16">{subtitle}</p>}
      </div>
    </div>;
}